<template>
	<base-modal
		ref="baseModal"
		:load-data="loadData"
		:send="send"
		:valid-form="true"
		:ok-title="$t('yes')"
		:cancel-title="$t('no')"
	>
		<h3 :class="[isRtl? 'rtl' : '']" >{{ $t("do_you_wish_to_logout_from_toolbar_too") }}</h3>
		<template v-slot:header> {{ $t("logout_title") }} </template>
	</base-modal>
</template>

<script>
import BaseModal from "./BaseModal";
import {EventBus} from "@/event-bus.js";

export default {
	props: ["socket"],
	computed: {
		isRtl() {
			return this.$i18n.locale === "he";
		}
	},
	components: { BaseModal },
	methods: {
		async open() {
			this.$refs.baseModal.open();
		},
		async loadData() {},
		async send() {
			if (this.socket)
				this.socket.disconnect();
			EventBus.$emit("USER_LOGOFF");
			let logOutUrl =	window.location.hash == "#/empty"
				? "#/login/toolbar"
				: "#/login";
			window.location.href = logOutUrl;
			return "ok";
		}
	}
};
</script>
<style scoped>
.rtl {
	direction: rtl;
	text-align: right;
}
</style>